import React, { useContext } from 'react';
import LoadingPage from '../../components/LoadingPage';
import PodContextProvider from './PodContextProvider';
import PodContext from './PodContext';

const withPodContext = (Component) => {
  const WrappedComponent = (props) => {
    const { isReady } = useContext(PodContext);
    return isReady ? <Component {...props} /> : <LoadingPage />;
  };

  return (props) => (
    <PodContextProvider>
      <WrappedComponent {...props} />
    </PodContextProvider>
  );
};

export { withPodContext };
